import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        this.raf = true;
        this.offset = this.element.getBoundingClientRect().top + window.scrollY;

        window.requestAnimationFrame(this._raf.bind(this));
    }

    disconnect() {
        this.raf = false;
    }

    _raf() {
        const headerHeight = document.querySelector('#header')?.getBoundingClientRect().height ?? 0;
        const sticky = window.scrollY > (this.offset - headerHeight);

        if (sticky) {
            this.element.style.top = `${window.scrollY - this.offset + headerHeight}px`;
        } else {
            this.element.removeAttribute('style');
        }

        if (this.raf) {
            window.requestAnimationFrame(this._raf.bind(this));
        }
    }
}
